import { render } from "./SectionOffer.vue?vue&type=template&id=b052958e&scoped=true"
import script from "./SectionOffer.vue?vue&type=script&lang=js"
export * from "./SectionOffer.vue?vue&type=script&lang=js"

import "./SectionOffer.vue?vue&type=style&index=0&id=b052958e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b052958e"]])

export default __exports__